import { defineComponent, onMounted, ref } from "vue";
import { gsap, ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);
export default defineComponent({
  props: {
    black: { type: String, required: true },
    gold: { type: String, required: true },
    grey: { type: String, required: true },
    color: { type: String, required: true },
    blacklink: { type: Object, required: false },
    goldlink: { type: Object, required: false },
    greylink: { type: Object, required: false },
    colorlink: { type: Object, required: false },
  },
  setup() {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore:next-line

    const pageSection = ref<HTMLElement | null>(null);
    // const gradientScroll = ref<gsap.core.Tween | null>(null);

    onMounted(() => {
      const colorSections = pageSection.value!.querySelectorAll<HTMLElement>(
        "[data-set-background-color]"
      );

      // gsap.set(colorSections, {
      //   background: `radial-gradient(circle, #ffffff 0%, transparent 70%)`,
      // });

      type ColorString = "black" | "gold" | "grey" | "color";

      const changeBackgroundColor = (color: ColorString): void => {
        const colorCodes = {
          black: "#1e1919",
          gold: "#ffce32",
          grey: "#87857b",
          color: "#414D99",
        };
        const changeColorTL = gsap.timeline({
          defaults: { overwrite: true },
          onComplete: function () {
            if (color !== "color") {
              return;
            }

            gsap.to(pageSection.value, {
              duration: 14,

              backgroundColor: "#D96E6C",
            });
          },
        });

        const animationDuration = 1.9;

        changeColorTL.to(
          pageSection.value,
          {
            duration: animationDuration,
            backgroundColor: colorCodes[color],
          },
          0
        );

        // changeColorTL.to(
        //   colorSections,
        //   {
        //     duration: animationDuration,
        //     background: `radial-gradient(circle, ${colorCodes[color]} 0%, transparent 70%)`,
        //   },
        //   0
        // );
      };

      for (let i = 0; i < colorSections.length; i++) {
        if (colorSections[i]) {
          const { setBackgroundColor = "black" } = colorSections[i]!.dataset;

          gsap.set(colorSections[i].querySelectorAll(".nmm_title__line"), {
            autoAlpha: 0,
          });

          ScrollTrigger.create({
            trigger: colorSections[i],
            start: "top 50%",
            end: "bottom 50%",

            onEnter: () => {
              changeBackgroundColor(setBackgroundColor as ColorString);
              gsap.set(colorSections[i].querySelectorAll(".nmm_title__line"), {
                autoAlpha: 1,
              });
              gsap.from(colorSections[i].querySelectorAll(".nmm_title__line"), {
                yPercent: 100,
                duration: 2.2,
                // delay: 0.5,
                ease: "power4.out",
                stagger: { amount: 0.4 },
              });
            },
            onEnterBack: () => {
              changeBackgroundColor(setBackgroundColor as ColorString);
            },
          });

          if (window.innerWidth > 768) {
            gsap
              .timeline({
                scrollTrigger: {
                  trigger: colorSections[i],
                  start: "top 60%",
                  end: "bottom top",
                  scrub: true,
                },
              })
              .fromTo(
                colorSections[i].querySelector(".intro__image"),
                { y: 50, ease: "none" },
                { y: -50, ease: "none" }
              );
          }
        }
      }

      // pin background images
      ScrollTrigger.create({
        trigger: pageSection.value,
        start: "top top",
        end: "bottom bottom",
        pin: pageSection.value!.querySelector(".intro__background_images"),
        pinType: "fixed",
      });
    });

    return { pageSection };
  },
});
